
import { Analytics } from "@vercel/analytics/react";
import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import BannerLine from "./components/BannerLine"; // Import BannerLine
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import ImageCarousel from "./components/ImageCarousel";
import NavigationBar from "./components/Navbar"; // Pass user props here
import ProductsSection from "./components/ProductsSection";
import ScrollToTop from "./components/ScrollToTop";
import TestimonialSection from "./components/TestimonialSection";
// Pages
import TrainerCourseDetail from "./components/TrainerCourseDetail";
import AboutUs from "./pages/AboutUs";
import AiTalentHub from "./pages/AiTalentHub";
import AiTraining from "./pages/AiTraining";
import AuthPage from "./pages/AuthPage"; // Should accept setUser
import CourseDetails from "./pages/CourseDetails";
import CourseOffered from "./pages/CourseOffered";
import CoursesPage from "./pages/CoursesPage";
import EachCourseDetail from "./pages/EachCourseDetail";
import ExpertReviewPanel from "./pages/ExpertReviewPanel";
import FutureTechTraining from "./pages/FutureTechTraining";
import OracleQEAutomation from "./pages/OracleQEAutomation";
import ProfilePage from "./pages/ProfilePage";
import ResumeAnalysis from "./pages/ResumeAnalysis";
import ResumeCorrection from "./pages/ResumeCorrection";
import ScoreMarkedTalent from "./pages/ScoreMarkedTalent";
import TrainerDetail from "./pages/TrainerDetails";
import TrainerHub from "./pages/TrainerHub";
import TrainerProfile from "./pages/TrainerProfile";
//  import StickyAdBox from "./components/StickyAdBox";
  import '@fortawesome/fontawesome-free/css/all.min.css';
import { logout } from "./API/res"; // Import the logout function 
import MockInterviewPage from './components/MockInterviewPage';
import OurPartner from "./components/OurPartner";
import InstilitWebpage from "./pages/InstilitWebpage";
import RegistrationDs from "./pages/RegistrationDs";
import ResumeBuilderApp from "./pages/ResumeBuilder";
import ThankYou from "./pages/ThankYou";


function App() {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

 useEffect(() => {
  const loggedIn = localStorage.getItem("isAuthenticated") === "true";
  const storedUser = localStorage.getItem("user");

  if (loggedIn && storedUser) {
    try {
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    } catch {
      console.error("Invalid user in localStorage");
    }
  }
}, []);


   

useEffect(() => {
  const setLastActiveTime = () => {
    localStorage.setItem('lastActiveTime', Date.now().toString());
  };

  const handleAutoLogout = async () => {
    const lastActive = parseInt(localStorage.getItem('lastActiveTime') || '0', 10);
    const now = Date.now();
    const timeout = 30 * 60 * 1000; // 30 mins

    if (now - lastActive > timeout) {
      try {
        await logout(); // API call
      } catch (e) {
        console.error("Auto logout API error:", e);
      }

      localStorage.removeItem("authToken");
      localStorage.removeItem("lastActiveTime");
      localStorage.removeItem("user");
      localStorage.setItem("isAuthenticated", "false");
      setUser(null);
      setIsAuthenticated(false);
      window.location.href = "/login";
    }
  };

  // Set time on interaction
  document.addEventListener("click", setLastActiveTime);
  document.addEventListener("mousemove", setLastActiveTime);
  setLastActiveTime(); // set on load

  const interval = setInterval(() => {
    handleAutoLogout();
  }, 60 * 1000); // check every minute

  return () => {
    document.removeEventListener("click", setLastActiveTime);
    document.removeEventListener("mousemove", setLastActiveTime);
    clearInterval(interval);
  };
}, []);

 

  return (
    <>
      {/* Banner Line Component */}
      <BannerLine message="🚀 Explore Our Courses" navigateTo='/coursesoffered' />

      {/* Navbar with user state */}
       <NavigationBar
        user={user}
        setUser={setUser}
        isAuthenticated={isAuthenticated}
        setIsAuthenticated={setIsAuthenticated}
      />

      <ScrollToTop />
      {/* <ScrollToHashElement /> */}
   
      <Routes>
        <Route
          path="/"
          element={
            <>
              <ImageCarousel />
              <ProductsSection />
              <TestimonialSection />
              <OurPartner />
              <ContactUs />
            </>
          }
        />
        
        <Route path="/futuretech-training" element={<FutureTechTraining />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/registrationds2589" element={<RegistrationDs />} />
        <Route path="/resume-analysis" element={<ResumeAnalysis />} />
        <Route path="/trainerprofile" element={<TrainerProfile />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/freelancer-trainer" element={<TrainerHub />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/instilit-Promo" element={<InstilitWebpage />} />
        <Route path="/Login" element={<AuthPage setUser={setUser} />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/ai-talent-hub" element={<AiTalentHub />} />
        <Route path="/ai-training" element={<AiTraining />} />
        <Route path="/oracle-qe-automation" element={<OracleQEAutomation />} />
        <Route path="/resume-correction" element={<ResumeCorrection />} />
        <Route path="/expert-review-panel" element={<ExpertReviewPanel />} />
        <Route path="/scoremarked-talent" element={<ScoreMarkedTalent />} />
        <Route path="/courses/details/:courseName" element={<CourseDetails />} />
        <Route path="/coursesoffered" element={<CourseOffered />} />
        <Route path="/mock-interview" element={<MockInterviewPage />} />
        <Route path="/profilepage" element={<ProfilePage />} />
        <Route path="/resume" element={<ResumeBuilderApp />} />

        {/* Extra routes from the updated version */}
        <Route path="/TrainerDetails" element={<TrainerDetail />} />
        <Route path="/courses/:courseId" element={<EachCourseDetail />} />
        <Route path="/trainer/:trainerId" element={<TrainerCourseDetail />} />
        <Route path="/trainer-courses/:trainerId" element={<TrainerCourseDetail />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/registrationds2589" element={<RegistrationDs />}/>
       
      </Routes>

      {/* {location.pathname === "/" && <StickyAdBox />}  */}
      <div>
        <Footer />
      </div>
      
      <Analytics />
    </>
  );
}

export default App;
